<!--
Author: TangChen
Date: 2018-12-07
Desc: 适当性协议内容
-->
<template>
    <div class="comp-fund-protocol comp">
        <el-checkbox name="type">
            <i>基金有风险，投资需谨慎，请查看</i><span v-for="item of protocol" :key="item.id" v-on:click.prevent="agreementCon(item)">《{{ item.title }}》</span>
        </el-checkbox>
        <el-dialog :title="protocolTitle" :visible.sync="centerDialogVisible" width="36%" :center="true">
            <div class="protocol-con">
                <i class="el-icon-warning" />
                <div class="protocol-msg" v-html="protocolHtml" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="centerDialogVisible = false">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
        <el-dialog :title="agrCon.title" :visible.sync="dialogVisible" :center="true">
            <div v-html="agrCon.content" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="dialogVisible = false">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "FundProtocol",
    props: {
        fund: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            agrCon: {},
            protocol: [],
            centerDialogVisible: false,
            dialogVisible: false,
            protocolTitle: "",
            protocolHtml: "",
            info: {}
        };
    },
    watch: {
        fund(){
            this.fundPopMes();
        }
    },
    created () {
        this.info = this.$cache.getUser();
        this.fundPopMes();
    },
    methods: {
        agreementCon (val) {
            let _this = this;
            this.protocolTitle = val.title;
            let _html = "";
            let _type = "";
            if (val.id < 4) {
                this.agreementText(val);
                return;
            }
            // upm协议内容
            if (val.ump) {
                this.$util.request("common/protocol/content", val).then(res => {
                    if (res.data) {
                        const con = res.data[0];
                        if (con) {
                            _this.agrCon = con;
                            _this.dialogVisible = true;
                        }
                    }
                });
            } else {
                // 适当性协议内容
                if (val.id === "4") {
                    _html = this.getMatchMsg();
                    _type = "1";
                } else if (val.id === "5") {
                    _html = this.riskWarning();
                } else if (val.id === "6") {
                    _type = "2";
                    _html = this.riskMismatch();
                } else if (val.id === "7") {
                    _type = "3";
                    _html = "您正在购买的产品属于<span class=\"red\">高风险</span>产品，请确认已经仔细阅读产品合同等法律文件以了解产品风险。";
                }
                this.protocolHtml = _html;
                if (_type !== "") {
                    this.$util.getRiskProtocol(_type).then(res => {
                        _this.protocolHtml += "<div>" + res + "</div>";
                        _this.centerDialogVisible = true;
                    });
                    return;
                }
                this.centerDialogVisible = true;
            }
        },
        // 查询具体合同内容
        agreementText (val) {
            let _this = this;
            const _data = {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                type: val.id,
                maintextno: this.fund.maintextno
            };
            this.$util.request("pef/trade/contract", _data).then(res => {
                if (res.data) {
                    const con = res.data[0];
                    if (con) {
                        con.title = val.title;
                        _this.agrCon = con;
                        _this.dialogVisible = true;
                    }
                }
            });
        },
        // 获取投资品种文字
        getKind (val) {
            if (val && val.trim() !== "") {
                const _arrKind = val.split(",");
                let _kindTextArr = [];
                _arrKind.forEach(arr => {
                    _kindTextArr.push(this.$cache.getDict("150072", arr));
                });
                return _kindTextArr.join("/");
            }
            return val;
        },
        // 获取适当性提示信息类型
        fundPopMes () {
            this.protocol = [];
            if (this.fund.needsignelecpaper === "1") {
                // 电子合同名称
                if (this.fund.contracttitle.trim() !== "") {
                    this.protocol.push({ id: "1", title: this.fund.contracttitle });
                }
                // 电子签名约定书名称
                if (this.fund.elecsigntitle.trim() !== "") {
                    this.protocol.push({ id: "3", title: this.fund.elecsigntitle });
                }
                // 风险揭示书名称
                if (this.fund.riskannouncetitle.trim() !== "") {
                    this.protocol.push({ id: "0", title: this.fund.riskannouncetitle });
                }
            }
            // ump添加协议获取
            if (this.fund.protoArr && this.fund.protoArr.length > 0) {
                const _x = this.fund.protoArr;
                for (let pro of _x) {
                    pro.ump = true;
                    this.protocol.push(pro);
                }
            }
            if (this.fund.fundmismatchflag === "1") {
                this.protocol.push({ id: "4", title: "投资品种/期限不匹配提示" });
            }
            if (this.fund.riskwarnflag === "1") {
                this.protocol.push({ id: "5", title: "风险提示书" });
            }
            if (this.fund.riskmismatchflag === "1") {
                this.protocol.push({ id: "6", title: "不匹配提示" });
            }
            if (this.fund.highriskwarnflag === "1") {
                this.protocol.push({ id: "7", title: "超风险提示" });
            }
        },
        riskMismatch () {
            return "您的风险评测结果是<span class=\"red\">" + this.$cache.getDict("100017", this.info.custrisk) + "</span>，所购买产品的风险等级为<span class=\"red\">" + this.$cache.getDict("110143", this.fund.risklevel) + "风险</span>" +
                    "，已超过您的风险承受能力，请确认已经仔细阅读产品合同等法律文件以了解产品风险，确认继续购买该产品并自愿承担产品风险。";
        },
        riskWarning () {
            const _this = this;
            const _riskWarningHtml = "<div>经营机构向普通投资者销售产品或者提供服务前，应当告知下列信息：</div>" +
                    "<ul class=\"k-risk-alert\">" +
                    "<li><span>（一）</span><p>可能直接导致本金亏损的事项；</p></li>" +
                    "<li><span>（二）</span><p>可能直接导致超过原始本金损失的事项</p></li>" +
                    "<li><span>（三）</span><p>因经营机构的业务或者财产状况变化，可能导致本金或者原始本金亏损的事项；</p></li>" +
                    "<li><span>（四）</span><p>因经营机构的业务或者财产状况变化，影响客户判断的重要事由；</p></li>" +
                    "<li><span>（五）</span><p>限制销售对象权利行使期限或者可解除合同期限等全部限制内容；</p></li>" +
                    "<li><span>（六）</span><p>本办法第二十九条规定的适当性匹配意见。</p></li></ul>" +
                    "<div>立即了解<span class=\"like-a\" onclick='law_click()'>《证券期货投资者适当性管理办法》</span></div>";
            window.law_click = function() {
                _this.$router.push({name:'policyAndLaw'});
            };
            return _riskWarningHtml;
        },
        // 绘制投资期限/品种不匹配提示信息弹框
        getMatchMsg () {
            const fund = this.fund;
            if (fund.fundmismatchflag === "1") {
                let _matchFlagText = "";
                const userInvestTerm = this.$cache.getDict("150071", fund.userinvestterm);
                const userInvestKind = this.getKind(fund.userinvesttype);
                const fundInvestTerm = this.$cache.getDict("150071", fund.investterm);
                const fundInvestKind = this.getKind(fund.investkind);
                if (fund.typemismatchflag === "1" && fund.termmismatchflag === "1") {
                    _matchFlagText = "您的投资品种为<span class=\"red\">" + userInvestKind + "</span>，投资期限为<span class=\"red\">" + userInvestTerm + "</span>，所购买产品的投资品种为<span class=\"red\">" + fundInvestKind + "</span>，投资期限为<span class=\"red\">" + fundInvestTerm + "</span>。";
                } else if (fund.termmismatchflag === "1") { // 投资期限
                    _matchFlagText = "您的投资期限为<span class=\"red\">" + userInvestTerm + "</span>，所购买产品的投资期限为<span class=\"red\">" + fundInvestTerm + "</span>。";
                } else if (fund.typemismatchflag === "1") { // 投资品种
                    _matchFlagText = "您的投资品种为<span class=\"red\">" + userInvestKind + "</span>，所购买产品的投资品种为<span class=\"red\">" + fundInvestKind + "</span>。";
                }
                return _matchFlagText;
            }
            return false;
        }
    }
};
</script>
<style lang="scss">
    .comp-fund-protocol {
        max-width: 800px;
        line-height: 20px;
        display: inline-block;
        .el-dialog__body {
            padding: 10px 20px;
        }
        .el-dialog {
            .el-dialog__header {
                line-height: 30px;
            }
        }
        .el-dialog__body {
            .protocol-con {
                line-height: 24px;
                position: relative;
                padding-left: 30px;
                .el-icon-warning {
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .k-risk-alert {
                    p {
                        display: inline-block;
                    }
                }
            }
        }
        .el-checkbox__input {
            vertical-align: top;
        }
        .el-checkbox__label {
            line-height: 20px;
            cursor: default;
            &:after {
                content: "";
                clear: both;
                overflow: hidden;
                display: block;
                height: 0;
            }
            i {
                font-style: normal;
                float: left;
            }
            span {
                cursor: pointer;
                display: inline-block;
                float: left;
                &:after {
                    content: "、";
                }
                &:last-child:after {
                    content: "";
                }
            }
        }
    }
</style>
